module.exports = __webpack_public_path__ + "spinner-dark.cd2d3e40.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/decorative/spinner-dark.png
// module id = ./public/assets/images/decorative/spinner-dark.png
// module chunks = main